import { ErrorBlock, InPageLoader } from '../../legacy/components';

export type LoadingStateContainerProps = {
  isLoading: boolean;
  failedToLoad: boolean;
  children: React.ReactNode;
};

const LoadingStateContainer = ({ isLoading, failedToLoad, children }: LoadingStateContainerProps) => {
  if (isLoading) {
    return <InPageLoader />;
  } else if (failedToLoad) {
    return <ErrorBlock errorMsg="Failed to load data, please try again later." />;
  }

  return <>{children}</>;
};

export default LoadingStateContainer;
